module.exports = __webpack_public_path__ + "img/doc.7bede160.svg";